// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_enums.entity.proto

/* eslint-disable */

export const protobufPackage = "stcs_cmw";

export enum StcsResCode {
  SUCCESS = 0,
  TECHNICAL_ERROR = 1,
  BUSINESS_ERROR = 2,
  VALIDATION_ERROR = 3,
  NOT_FOUND = 4,
  NOT_AUTHORIZED = 5,
  UNRECOGNIZED = -1,
}

export function stcsResCodeFromJSON(object: any): StcsResCode {
  switch (object) {
    case 0:
    case "SUCCESS":
      return StcsResCode.SUCCESS;
    case 1:
    case "TECHNICAL_ERROR":
      return StcsResCode.TECHNICAL_ERROR;
    case 2:
    case "BUSINESS_ERROR":
      return StcsResCode.BUSINESS_ERROR;
    case 3:
    case "VALIDATION_ERROR":
      return StcsResCode.VALIDATION_ERROR;
    case 4:
    case "NOT_FOUND":
      return StcsResCode.NOT_FOUND;
    case 5:
    case "NOT_AUTHORIZED":
      return StcsResCode.NOT_AUTHORIZED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StcsResCode.UNRECOGNIZED;
  }
}

export function stcsResCodeToJSON(object: StcsResCode): string {
  switch (object) {
    case StcsResCode.SUCCESS:
      return "SUCCESS";
    case StcsResCode.TECHNICAL_ERROR:
      return "TECHNICAL_ERROR";
    case StcsResCode.BUSINESS_ERROR:
      return "BUSINESS_ERROR";
    case StcsResCode.VALIDATION_ERROR:
      return "VALIDATION_ERROR";
    case StcsResCode.NOT_FOUND:
      return "NOT_FOUND";
    case StcsResCode.NOT_AUTHORIZED:
      return "NOT_AUTHORIZED";
    case StcsResCode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum STCS_NAMESPACE {
  STCS_NAME_SPACE_MISSING = 0,
  STCS_DEV = 1,
  STCS_CLOSED_BETA = 2,
  UNRECOGNIZED = -1,
}

export function sTCS_NAMESPACEFromJSON(object: any): STCS_NAMESPACE {
  switch (object) {
    case 0:
    case "STCS_NAME_SPACE_MISSING":
      return STCS_NAMESPACE.STCS_NAME_SPACE_MISSING;
    case 1:
    case "STCS_DEV":
      return STCS_NAMESPACE.STCS_DEV;
    case 2:
    case "STCS_CLOSED_BETA":
      return STCS_NAMESPACE.STCS_CLOSED_BETA;
    case -1:
    case "UNRECOGNIZED":
    default:
      return STCS_NAMESPACE.UNRECOGNIZED;
  }
}

export function sTCS_NAMESPACEToJSON(object: STCS_NAMESPACE): string {
  switch (object) {
    case STCS_NAMESPACE.STCS_NAME_SPACE_MISSING:
      return "STCS_NAME_SPACE_MISSING";
    case STCS_NAMESPACE.STCS_DEV:
      return "STCS_DEV";
    case STCS_NAMESPACE.STCS_CLOSED_BETA:
      return "STCS_CLOSED_BETA";
    case STCS_NAMESPACE.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum StcsOrgRoleEnum {
  SORE_NOT_DEFINED = 0,
  SORE_ROLE_SUPER_ADMIN = 10,
  SORE_ROLE_ADMIN = 11,
  SORE_ROLE_EDITOR = 30,
  SORE_ROLE_VIEWER = 40,
  SORE_ROLE_NO_SEAT_GUEST = 50,
  SORE_ROLE_ONBOARDING = 60,
  UNRECOGNIZED = -1,
}

export function stcsOrgRoleEnumFromJSON(object: any): StcsOrgRoleEnum {
  switch (object) {
    case 0:
    case "SORE_NOT_DEFINED":
      return StcsOrgRoleEnum.SORE_NOT_DEFINED;
    case 10:
    case "SORE_ROLE_SUPER_ADMIN":
      return StcsOrgRoleEnum.SORE_ROLE_SUPER_ADMIN;
    case 11:
    case "SORE_ROLE_ADMIN":
      return StcsOrgRoleEnum.SORE_ROLE_ADMIN;
    case 30:
    case "SORE_ROLE_EDITOR":
      return StcsOrgRoleEnum.SORE_ROLE_EDITOR;
    case 40:
    case "SORE_ROLE_VIEWER":
      return StcsOrgRoleEnum.SORE_ROLE_VIEWER;
    case 50:
    case "SORE_ROLE_NO_SEAT_GUEST":
      return StcsOrgRoleEnum.SORE_ROLE_NO_SEAT_GUEST;
    case 60:
    case "SORE_ROLE_ONBOARDING":
      return StcsOrgRoleEnum.SORE_ROLE_ONBOARDING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StcsOrgRoleEnum.UNRECOGNIZED;
  }
}

export function stcsOrgRoleEnumToJSON(object: StcsOrgRoleEnum): string {
  switch (object) {
    case StcsOrgRoleEnum.SORE_NOT_DEFINED:
      return "SORE_NOT_DEFINED";
    case StcsOrgRoleEnum.SORE_ROLE_SUPER_ADMIN:
      return "SORE_ROLE_SUPER_ADMIN";
    case StcsOrgRoleEnum.SORE_ROLE_ADMIN:
      return "SORE_ROLE_ADMIN";
    case StcsOrgRoleEnum.SORE_ROLE_EDITOR:
      return "SORE_ROLE_EDITOR";
    case StcsOrgRoleEnum.SORE_ROLE_VIEWER:
      return "SORE_ROLE_VIEWER";
    case StcsOrgRoleEnum.SORE_ROLE_NO_SEAT_GUEST:
      return "SORE_ROLE_NO_SEAT_GUEST";
    case StcsOrgRoleEnum.SORE_ROLE_ONBOARDING:
      return "SORE_ROLE_ONBOARDING";
    case StcsOrgRoleEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum StcsCompRoleEnum {
  SCRE_NOT_DEFINED = 0,
  SCRE_ROLE_ADMIN = 1,
  SCRE_ROLE_EDITOR = 2,
  SCRE_ROLE_VIEWER = 3,
  SCRE_ROLE_NO_SEAT_GUEST = 4,
  SCRE_ROLE_ONBOARDING = 5,
  UNRECOGNIZED = -1,
}

export function stcsCompRoleEnumFromJSON(object: any): StcsCompRoleEnum {
  switch (object) {
    case 0:
    case "SCRE_NOT_DEFINED":
      return StcsCompRoleEnum.SCRE_NOT_DEFINED;
    case 1:
    case "SCRE_ROLE_ADMIN":
      return StcsCompRoleEnum.SCRE_ROLE_ADMIN;
    case 2:
    case "SCRE_ROLE_EDITOR":
      return StcsCompRoleEnum.SCRE_ROLE_EDITOR;
    case 3:
    case "SCRE_ROLE_VIEWER":
      return StcsCompRoleEnum.SCRE_ROLE_VIEWER;
    case 4:
    case "SCRE_ROLE_NO_SEAT_GUEST":
      return StcsCompRoleEnum.SCRE_ROLE_NO_SEAT_GUEST;
    case 5:
    case "SCRE_ROLE_ONBOARDING":
      return StcsCompRoleEnum.SCRE_ROLE_ONBOARDING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StcsCompRoleEnum.UNRECOGNIZED;
  }
}

export function stcsCompRoleEnumToJSON(object: StcsCompRoleEnum): string {
  switch (object) {
    case StcsCompRoleEnum.SCRE_NOT_DEFINED:
      return "SCRE_NOT_DEFINED";
    case StcsCompRoleEnum.SCRE_ROLE_ADMIN:
      return "SCRE_ROLE_ADMIN";
    case StcsCompRoleEnum.SCRE_ROLE_EDITOR:
      return "SCRE_ROLE_EDITOR";
    case StcsCompRoleEnum.SCRE_ROLE_VIEWER:
      return "SCRE_ROLE_VIEWER";
    case StcsCompRoleEnum.SCRE_ROLE_NO_SEAT_GUEST:
      return "SCRE_ROLE_NO_SEAT_GUEST";
    case StcsCompRoleEnum.SCRE_ROLE_ONBOARDING:
      return "SCRE_ROLE_ONBOARDING";
    case StcsCompRoleEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum StcsEntityStatusEnum {
  SES_NONE = 0,
  SES_ACTIVE = 1,
  SES_APPROVED = 8,
  SES_ARCHIVED = 4,
  SES_CANCELLED = 13,
  SES_COMPLETED = 14,
  SES_DELETED = 3,
  SES_DELETE_MANDATE = 50,
  SES_EXPIRED = 11,
  SES_FAILED = 15,
  SES_INACTIVE = 2,
  SES_LOCKED = 9,
  SES_PENDING = 6,
  SES_PENDING_ACC_MAPPING = 53,
  SES_PENDING_APPROVAL = 16,
  SES_PENDING_ARCHIVAL = 19,
  SES_PENDING_ARCHIVAL_REACTIVATION = 34,
  SES_PENDING_ARCHIVAL_RECOVERY = 33,
  SES_PENDING_CANCELLATION = 22,
  SES_PENDING_CANCELLATION_REACTIVATION = 40,
  SES_PENDING_CANCELLATION_RECOVERY = 39,
  SES_PENDING_COMPLETION = 23,
  SES_PENDING_COMPLETION_REACTIVATION = 42,
  SES_PENDING_COMPLETION_RECOVERY = 41,
  SES_PENDING_DATA = 51,
  SES_PENDING_DELETION = 18,
  SES_PENDING_DELETION_REACTIVATION = 32,
  SES_PENDING_DELETION_RECOVERY = 31,
  SES_PENDING_EXPIRATION = 24,
  SES_PENDING_EXPIRATION_REACTIVATION = 44,
  SES_PENDING_EXPIRATION_RECOVERY = 43,
  SES_PENDING_FINANCIALS = 54,
  SES_PENDING_FSD = 55,
  SES_PENDING_LOCK = 26,
  SES_PENDING_LOCK_REACTIVATION = 48,
  SES_PENDING_LOCK_RECOVERY = 47,
  SES_PENDING_PAYMENT_APPROVAL = 56,
  SES_PENDING_PLAN = 57,
  SES_PENDING_REACTIVATION = 28,
  SES_PENDING_RECOVERY = 27,
  SES_PENDING_RECOVERY_REJECTION = 49,
  SES_PENDING_REJECTION = 17,
  SES_PENDING_REJECTION_REACTIVATION = 30,
  SES_PENDING_REJECTION_RECOVERY = 29,
  SES_PENDING_RENEWAL = 21,
  SES_PENDING_RENEWAL_REACTIVATION = 38,
  SES_PENDING_RENEWAL_RECOVERY = 37,
  SES_PENDING_SUSPENSION = 20,
  SES_PENDING_SUSPENSION_REACTIVATION = 36,
  SES_PENDING_SUSPENSION_RECOVERY = 35,
  SES_PENDING_UNLOCK = 25,
  SES_PENDING_UNLOCK_REACTIVATION = 46,
  SES_PENDING_UNLOCK_RECOVERY = 45,
  SES_REGISTERED = 52,
  SES_REJECTED = 7,
  SES_RENEWED = 12,
  SES_SANDBOX = 58,
  SES_SUSPENDED = 5,
  SES_UNLOCKED = 10,
  UNRECOGNIZED = -1,
}

export function stcsEntityStatusEnumFromJSON(object: any): StcsEntityStatusEnum {
  switch (object) {
    case 0:
    case "SES_NONE":
      return StcsEntityStatusEnum.SES_NONE;
    case 1:
    case "SES_ACTIVE":
      return StcsEntityStatusEnum.SES_ACTIVE;
    case 8:
    case "SES_APPROVED":
      return StcsEntityStatusEnum.SES_APPROVED;
    case 4:
    case "SES_ARCHIVED":
      return StcsEntityStatusEnum.SES_ARCHIVED;
    case 13:
    case "SES_CANCELLED":
      return StcsEntityStatusEnum.SES_CANCELLED;
    case 14:
    case "SES_COMPLETED":
      return StcsEntityStatusEnum.SES_COMPLETED;
    case 3:
    case "SES_DELETED":
      return StcsEntityStatusEnum.SES_DELETED;
    case 50:
    case "SES_DELETE_MANDATE":
      return StcsEntityStatusEnum.SES_DELETE_MANDATE;
    case 11:
    case "SES_EXPIRED":
      return StcsEntityStatusEnum.SES_EXPIRED;
    case 15:
    case "SES_FAILED":
      return StcsEntityStatusEnum.SES_FAILED;
    case 2:
    case "SES_INACTIVE":
      return StcsEntityStatusEnum.SES_INACTIVE;
    case 9:
    case "SES_LOCKED":
      return StcsEntityStatusEnum.SES_LOCKED;
    case 6:
    case "SES_PENDING":
      return StcsEntityStatusEnum.SES_PENDING;
    case 53:
    case "SES_PENDING_ACC_MAPPING":
      return StcsEntityStatusEnum.SES_PENDING_ACC_MAPPING;
    case 16:
    case "SES_PENDING_APPROVAL":
      return StcsEntityStatusEnum.SES_PENDING_APPROVAL;
    case 19:
    case "SES_PENDING_ARCHIVAL":
      return StcsEntityStatusEnum.SES_PENDING_ARCHIVAL;
    case 34:
    case "SES_PENDING_ARCHIVAL_REACTIVATION":
      return StcsEntityStatusEnum.SES_PENDING_ARCHIVAL_REACTIVATION;
    case 33:
    case "SES_PENDING_ARCHIVAL_RECOVERY":
      return StcsEntityStatusEnum.SES_PENDING_ARCHIVAL_RECOVERY;
    case 22:
    case "SES_PENDING_CANCELLATION":
      return StcsEntityStatusEnum.SES_PENDING_CANCELLATION;
    case 40:
    case "SES_PENDING_CANCELLATION_REACTIVATION":
      return StcsEntityStatusEnum.SES_PENDING_CANCELLATION_REACTIVATION;
    case 39:
    case "SES_PENDING_CANCELLATION_RECOVERY":
      return StcsEntityStatusEnum.SES_PENDING_CANCELLATION_RECOVERY;
    case 23:
    case "SES_PENDING_COMPLETION":
      return StcsEntityStatusEnum.SES_PENDING_COMPLETION;
    case 42:
    case "SES_PENDING_COMPLETION_REACTIVATION":
      return StcsEntityStatusEnum.SES_PENDING_COMPLETION_REACTIVATION;
    case 41:
    case "SES_PENDING_COMPLETION_RECOVERY":
      return StcsEntityStatusEnum.SES_PENDING_COMPLETION_RECOVERY;
    case 51:
    case "SES_PENDING_DATA":
      return StcsEntityStatusEnum.SES_PENDING_DATA;
    case 18:
    case "SES_PENDING_DELETION":
      return StcsEntityStatusEnum.SES_PENDING_DELETION;
    case 32:
    case "SES_PENDING_DELETION_REACTIVATION":
      return StcsEntityStatusEnum.SES_PENDING_DELETION_REACTIVATION;
    case 31:
    case "SES_PENDING_DELETION_RECOVERY":
      return StcsEntityStatusEnum.SES_PENDING_DELETION_RECOVERY;
    case 24:
    case "SES_PENDING_EXPIRATION":
      return StcsEntityStatusEnum.SES_PENDING_EXPIRATION;
    case 44:
    case "SES_PENDING_EXPIRATION_REACTIVATION":
      return StcsEntityStatusEnum.SES_PENDING_EXPIRATION_REACTIVATION;
    case 43:
    case "SES_PENDING_EXPIRATION_RECOVERY":
      return StcsEntityStatusEnum.SES_PENDING_EXPIRATION_RECOVERY;
    case 54:
    case "SES_PENDING_FINANCIALS":
      return StcsEntityStatusEnum.SES_PENDING_FINANCIALS;
    case 55:
    case "SES_PENDING_FSD":
      return StcsEntityStatusEnum.SES_PENDING_FSD;
    case 26:
    case "SES_PENDING_LOCK":
      return StcsEntityStatusEnum.SES_PENDING_LOCK;
    case 48:
    case "SES_PENDING_LOCK_REACTIVATION":
      return StcsEntityStatusEnum.SES_PENDING_LOCK_REACTIVATION;
    case 47:
    case "SES_PENDING_LOCK_RECOVERY":
      return StcsEntityStatusEnum.SES_PENDING_LOCK_RECOVERY;
    case 56:
    case "SES_PENDING_PAYMENT_APPROVAL":
      return StcsEntityStatusEnum.SES_PENDING_PAYMENT_APPROVAL;
    case 57:
    case "SES_PENDING_PLAN":
      return StcsEntityStatusEnum.SES_PENDING_PLAN;
    case 28:
    case "SES_PENDING_REACTIVATION":
      return StcsEntityStatusEnum.SES_PENDING_REACTIVATION;
    case 27:
    case "SES_PENDING_RECOVERY":
      return StcsEntityStatusEnum.SES_PENDING_RECOVERY;
    case 49:
    case "SES_PENDING_RECOVERY_REJECTION":
      return StcsEntityStatusEnum.SES_PENDING_RECOVERY_REJECTION;
    case 17:
    case "SES_PENDING_REJECTION":
      return StcsEntityStatusEnum.SES_PENDING_REJECTION;
    case 30:
    case "SES_PENDING_REJECTION_REACTIVATION":
      return StcsEntityStatusEnum.SES_PENDING_REJECTION_REACTIVATION;
    case 29:
    case "SES_PENDING_REJECTION_RECOVERY":
      return StcsEntityStatusEnum.SES_PENDING_REJECTION_RECOVERY;
    case 21:
    case "SES_PENDING_RENEWAL":
      return StcsEntityStatusEnum.SES_PENDING_RENEWAL;
    case 38:
    case "SES_PENDING_RENEWAL_REACTIVATION":
      return StcsEntityStatusEnum.SES_PENDING_RENEWAL_REACTIVATION;
    case 37:
    case "SES_PENDING_RENEWAL_RECOVERY":
      return StcsEntityStatusEnum.SES_PENDING_RENEWAL_RECOVERY;
    case 20:
    case "SES_PENDING_SUSPENSION":
      return StcsEntityStatusEnum.SES_PENDING_SUSPENSION;
    case 36:
    case "SES_PENDING_SUSPENSION_REACTIVATION":
      return StcsEntityStatusEnum.SES_PENDING_SUSPENSION_REACTIVATION;
    case 35:
    case "SES_PENDING_SUSPENSION_RECOVERY":
      return StcsEntityStatusEnum.SES_PENDING_SUSPENSION_RECOVERY;
    case 25:
    case "SES_PENDING_UNLOCK":
      return StcsEntityStatusEnum.SES_PENDING_UNLOCK;
    case 46:
    case "SES_PENDING_UNLOCK_REACTIVATION":
      return StcsEntityStatusEnum.SES_PENDING_UNLOCK_REACTIVATION;
    case 45:
    case "SES_PENDING_UNLOCK_RECOVERY":
      return StcsEntityStatusEnum.SES_PENDING_UNLOCK_RECOVERY;
    case 52:
    case "SES_REGISTERED":
      return StcsEntityStatusEnum.SES_REGISTERED;
    case 7:
    case "SES_REJECTED":
      return StcsEntityStatusEnum.SES_REJECTED;
    case 12:
    case "SES_RENEWED":
      return StcsEntityStatusEnum.SES_RENEWED;
    case 58:
    case "SES_SANDBOX":
      return StcsEntityStatusEnum.SES_SANDBOX;
    case 5:
    case "SES_SUSPENDED":
      return StcsEntityStatusEnum.SES_SUSPENDED;
    case 10:
    case "SES_UNLOCKED":
      return StcsEntityStatusEnum.SES_UNLOCKED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StcsEntityStatusEnum.UNRECOGNIZED;
  }
}

export function stcsEntityStatusEnumToJSON(object: StcsEntityStatusEnum): string {
  switch (object) {
    case StcsEntityStatusEnum.SES_NONE:
      return "SES_NONE";
    case StcsEntityStatusEnum.SES_ACTIVE:
      return "SES_ACTIVE";
    case StcsEntityStatusEnum.SES_APPROVED:
      return "SES_APPROVED";
    case StcsEntityStatusEnum.SES_ARCHIVED:
      return "SES_ARCHIVED";
    case StcsEntityStatusEnum.SES_CANCELLED:
      return "SES_CANCELLED";
    case StcsEntityStatusEnum.SES_COMPLETED:
      return "SES_COMPLETED";
    case StcsEntityStatusEnum.SES_DELETED:
      return "SES_DELETED";
    case StcsEntityStatusEnum.SES_DELETE_MANDATE:
      return "SES_DELETE_MANDATE";
    case StcsEntityStatusEnum.SES_EXPIRED:
      return "SES_EXPIRED";
    case StcsEntityStatusEnum.SES_FAILED:
      return "SES_FAILED";
    case StcsEntityStatusEnum.SES_INACTIVE:
      return "SES_INACTIVE";
    case StcsEntityStatusEnum.SES_LOCKED:
      return "SES_LOCKED";
    case StcsEntityStatusEnum.SES_PENDING:
      return "SES_PENDING";
    case StcsEntityStatusEnum.SES_PENDING_ACC_MAPPING:
      return "SES_PENDING_ACC_MAPPING";
    case StcsEntityStatusEnum.SES_PENDING_APPROVAL:
      return "SES_PENDING_APPROVAL";
    case StcsEntityStatusEnum.SES_PENDING_ARCHIVAL:
      return "SES_PENDING_ARCHIVAL";
    case StcsEntityStatusEnum.SES_PENDING_ARCHIVAL_REACTIVATION:
      return "SES_PENDING_ARCHIVAL_REACTIVATION";
    case StcsEntityStatusEnum.SES_PENDING_ARCHIVAL_RECOVERY:
      return "SES_PENDING_ARCHIVAL_RECOVERY";
    case StcsEntityStatusEnum.SES_PENDING_CANCELLATION:
      return "SES_PENDING_CANCELLATION";
    case StcsEntityStatusEnum.SES_PENDING_CANCELLATION_REACTIVATION:
      return "SES_PENDING_CANCELLATION_REACTIVATION";
    case StcsEntityStatusEnum.SES_PENDING_CANCELLATION_RECOVERY:
      return "SES_PENDING_CANCELLATION_RECOVERY";
    case StcsEntityStatusEnum.SES_PENDING_COMPLETION:
      return "SES_PENDING_COMPLETION";
    case StcsEntityStatusEnum.SES_PENDING_COMPLETION_REACTIVATION:
      return "SES_PENDING_COMPLETION_REACTIVATION";
    case StcsEntityStatusEnum.SES_PENDING_COMPLETION_RECOVERY:
      return "SES_PENDING_COMPLETION_RECOVERY";
    case StcsEntityStatusEnum.SES_PENDING_DATA:
      return "SES_PENDING_DATA";
    case StcsEntityStatusEnum.SES_PENDING_DELETION:
      return "SES_PENDING_DELETION";
    case StcsEntityStatusEnum.SES_PENDING_DELETION_REACTIVATION:
      return "SES_PENDING_DELETION_REACTIVATION";
    case StcsEntityStatusEnum.SES_PENDING_DELETION_RECOVERY:
      return "SES_PENDING_DELETION_RECOVERY";
    case StcsEntityStatusEnum.SES_PENDING_EXPIRATION:
      return "SES_PENDING_EXPIRATION";
    case StcsEntityStatusEnum.SES_PENDING_EXPIRATION_REACTIVATION:
      return "SES_PENDING_EXPIRATION_REACTIVATION";
    case StcsEntityStatusEnum.SES_PENDING_EXPIRATION_RECOVERY:
      return "SES_PENDING_EXPIRATION_RECOVERY";
    case StcsEntityStatusEnum.SES_PENDING_FINANCIALS:
      return "SES_PENDING_FINANCIALS";
    case StcsEntityStatusEnum.SES_PENDING_FSD:
      return "SES_PENDING_FSD";
    case StcsEntityStatusEnum.SES_PENDING_LOCK:
      return "SES_PENDING_LOCK";
    case StcsEntityStatusEnum.SES_PENDING_LOCK_REACTIVATION:
      return "SES_PENDING_LOCK_REACTIVATION";
    case StcsEntityStatusEnum.SES_PENDING_LOCK_RECOVERY:
      return "SES_PENDING_LOCK_RECOVERY";
    case StcsEntityStatusEnum.SES_PENDING_PAYMENT_APPROVAL:
      return "SES_PENDING_PAYMENT_APPROVAL";
    case StcsEntityStatusEnum.SES_PENDING_PLAN:
      return "SES_PENDING_PLAN";
    case StcsEntityStatusEnum.SES_PENDING_REACTIVATION:
      return "SES_PENDING_REACTIVATION";
    case StcsEntityStatusEnum.SES_PENDING_RECOVERY:
      return "SES_PENDING_RECOVERY";
    case StcsEntityStatusEnum.SES_PENDING_RECOVERY_REJECTION:
      return "SES_PENDING_RECOVERY_REJECTION";
    case StcsEntityStatusEnum.SES_PENDING_REJECTION:
      return "SES_PENDING_REJECTION";
    case StcsEntityStatusEnum.SES_PENDING_REJECTION_REACTIVATION:
      return "SES_PENDING_REJECTION_REACTIVATION";
    case StcsEntityStatusEnum.SES_PENDING_REJECTION_RECOVERY:
      return "SES_PENDING_REJECTION_RECOVERY";
    case StcsEntityStatusEnum.SES_PENDING_RENEWAL:
      return "SES_PENDING_RENEWAL";
    case StcsEntityStatusEnum.SES_PENDING_RENEWAL_REACTIVATION:
      return "SES_PENDING_RENEWAL_REACTIVATION";
    case StcsEntityStatusEnum.SES_PENDING_RENEWAL_RECOVERY:
      return "SES_PENDING_RENEWAL_RECOVERY";
    case StcsEntityStatusEnum.SES_PENDING_SUSPENSION:
      return "SES_PENDING_SUSPENSION";
    case StcsEntityStatusEnum.SES_PENDING_SUSPENSION_REACTIVATION:
      return "SES_PENDING_SUSPENSION_REACTIVATION";
    case StcsEntityStatusEnum.SES_PENDING_SUSPENSION_RECOVERY:
      return "SES_PENDING_SUSPENSION_RECOVERY";
    case StcsEntityStatusEnum.SES_PENDING_UNLOCK:
      return "SES_PENDING_UNLOCK";
    case StcsEntityStatusEnum.SES_PENDING_UNLOCK_REACTIVATION:
      return "SES_PENDING_UNLOCK_REACTIVATION";
    case StcsEntityStatusEnum.SES_PENDING_UNLOCK_RECOVERY:
      return "SES_PENDING_UNLOCK_RECOVERY";
    case StcsEntityStatusEnum.SES_REGISTERED:
      return "SES_REGISTERED";
    case StcsEntityStatusEnum.SES_REJECTED:
      return "SES_REJECTED";
    case StcsEntityStatusEnum.SES_RENEWED:
      return "SES_RENEWED";
    case StcsEntityStatusEnum.SES_SANDBOX:
      return "SES_SANDBOX";
    case StcsEntityStatusEnum.SES_SUSPENDED:
      return "SES_SUSPENDED";
    case StcsEntityStatusEnum.SES_UNLOCKED:
      return "SES_UNLOCKED";
    case StcsEntityStatusEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum StcsPubSubStatusEnum {
  SPSS_NONE = 0,
  SPSS_PENDING = 1,
  SPSS_PROCESSING = 2,
  SPSS_COMPLETED = 3,
  SPSS_FAILED = 4,
  UNRECOGNIZED = -1,
}

export function stcsPubSubStatusEnumFromJSON(object: any): StcsPubSubStatusEnum {
  switch (object) {
    case 0:
    case "SPSS_NONE":
      return StcsPubSubStatusEnum.SPSS_NONE;
    case 1:
    case "SPSS_PENDING":
      return StcsPubSubStatusEnum.SPSS_PENDING;
    case 2:
    case "SPSS_PROCESSING":
      return StcsPubSubStatusEnum.SPSS_PROCESSING;
    case 3:
    case "SPSS_COMPLETED":
      return StcsPubSubStatusEnum.SPSS_COMPLETED;
    case 4:
    case "SPSS_FAILED":
      return StcsPubSubStatusEnum.SPSS_FAILED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StcsPubSubStatusEnum.UNRECOGNIZED;
  }
}

export function stcsPubSubStatusEnumToJSON(object: StcsPubSubStatusEnum): string {
  switch (object) {
    case StcsPubSubStatusEnum.SPSS_NONE:
      return "SPSS_NONE";
    case StcsPubSubStatusEnum.SPSS_PENDING:
      return "SPSS_PENDING";
    case StcsPubSubStatusEnum.SPSS_PROCESSING:
      return "SPSS_PROCESSING";
    case StcsPubSubStatusEnum.SPSS_COMPLETED:
      return "SPSS_COMPLETED";
    case StcsPubSubStatusEnum.SPSS_FAILED:
      return "SPSS_FAILED";
    case StcsPubSubStatusEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum StcsPubSubActionEnum {
  STCS_EVT_NONE = 0,
  STCS_EVT_FPNA_CONVERT_FSD_TO_FSTMT = 1,
  STCS_EVT_FPNA_PROCESS_ACC_DATA_TO_ACTUALS = 2,
  STCS_EVT_FPNA_PROCESS_PLAN_CFG_TO_PLAN_RES = 3,
  UNRECOGNIZED = -1,
}

export function stcsPubSubActionEnumFromJSON(object: any): StcsPubSubActionEnum {
  switch (object) {
    case 0:
    case "STCS_EVT_NONE":
      return StcsPubSubActionEnum.STCS_EVT_NONE;
    case 1:
    case "STCS_EVT_FPNA_CONVERT_FSD_TO_FSTMT":
      return StcsPubSubActionEnum.STCS_EVT_FPNA_CONVERT_FSD_TO_FSTMT;
    case 2:
    case "STCS_EVT_FPNA_PROCESS_ACC_DATA_TO_ACTUALS":
      return StcsPubSubActionEnum.STCS_EVT_FPNA_PROCESS_ACC_DATA_TO_ACTUALS;
    case 3:
    case "STCS_EVT_FPNA_PROCESS_PLAN_CFG_TO_PLAN_RES":
      return StcsPubSubActionEnum.STCS_EVT_FPNA_PROCESS_PLAN_CFG_TO_PLAN_RES;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StcsPubSubActionEnum.UNRECOGNIZED;
  }
}

export function stcsPubSubActionEnumToJSON(object: StcsPubSubActionEnum): string {
  switch (object) {
    case StcsPubSubActionEnum.STCS_EVT_NONE:
      return "STCS_EVT_NONE";
    case StcsPubSubActionEnum.STCS_EVT_FPNA_CONVERT_FSD_TO_FSTMT:
      return "STCS_EVT_FPNA_CONVERT_FSD_TO_FSTMT";
    case StcsPubSubActionEnum.STCS_EVT_FPNA_PROCESS_ACC_DATA_TO_ACTUALS:
      return "STCS_EVT_FPNA_PROCESS_ACC_DATA_TO_ACTUALS";
    case StcsPubSubActionEnum.STCS_EVT_FPNA_PROCESS_PLAN_CFG_TO_PLAN_RES:
      return "STCS_EVT_FPNA_PROCESS_PLAN_CFG_TO_PLAN_RES";
    case StcsPubSubActionEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum StcsEventOriginEnum {
  STCS_EVO_NONE = 0,
  STCS_EVO_WAPP = 1,
  STCS_EVO_CMW = 2,
  STCS_EVO_FPNA_DFA = 3,
  STCS_EVO_FPNA_CORE = 4,
  UNRECOGNIZED = -1,
}

export function stcsEventOriginEnumFromJSON(object: any): StcsEventOriginEnum {
  switch (object) {
    case 0:
    case "STCS_EVO_NONE":
      return StcsEventOriginEnum.STCS_EVO_NONE;
    case 1:
    case "STCS_EVO_WAPP":
      return StcsEventOriginEnum.STCS_EVO_WAPP;
    case 2:
    case "STCS_EVO_CMW":
      return StcsEventOriginEnum.STCS_EVO_CMW;
    case 3:
    case "STCS_EVO_FPNA_DFA":
      return StcsEventOriginEnum.STCS_EVO_FPNA_DFA;
    case 4:
    case "STCS_EVO_FPNA_CORE":
      return StcsEventOriginEnum.STCS_EVO_FPNA_CORE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StcsEventOriginEnum.UNRECOGNIZED;
  }
}

export function stcsEventOriginEnumToJSON(object: StcsEventOriginEnum): string {
  switch (object) {
    case StcsEventOriginEnum.STCS_EVO_NONE:
      return "STCS_EVO_NONE";
    case StcsEventOriginEnum.STCS_EVO_WAPP:
      return "STCS_EVO_WAPP";
    case StcsEventOriginEnum.STCS_EVO_CMW:
      return "STCS_EVO_CMW";
    case StcsEventOriginEnum.STCS_EVO_FPNA_DFA:
      return "STCS_EVO_FPNA_DFA";
    case StcsEventOriginEnum.STCS_EVO_FPNA_CORE:
      return "STCS_EVO_FPNA_CORE";
    case StcsEventOriginEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum StcsFpnaTypeEnum {
  /** SFT_ENUM_NONE - None */
  SFT_ENUM_NONE = 0,
  /** SFT_TOTAL_CML - Total CML, this can be a parent of other Totals or Sub Totals */
  SFT_TOTAL_CML = 1,
  /** SFT_TOTAL_NCML - Total NCML */
  SFT_TOTAL_NCML = 2,
  /** SFT_SUB_TOTAL - Sub Total, can be skipped sometimes, meaning that Total has no sub total as child but only level 1 childs */
  SFT_SUB_TOTAL = 3,
  /** SFT_LEVEL_1 - Level 1, child of a Total or Sub Total */
  SFT_LEVEL_1 = 4,
  /** SFT_LEVEL_2 - Level 2, child of a Level 1 */
  SFT_LEVEL_2 = 5,
  /** SFT_LEVEL_3 - Level 3, child of a Level 2, not used in FSD */
  SFT_LEVEL_3 = 6,
  /** SFT_ACC_ITEM - Account Item, child of a Level 3, not used in FSD */
  SFT_ACC_ITEM = 7,
  /** SFT_CTX_LINE_IPO - Total Context Line IPO, assistant element for Totals, always below a Total */
  SFT_CTX_LINE_IPO = 8,
  /** SFT_CTX_LINE_GROWTH - Total Context Line Growth, assistant element for Totals, always below a Total */
  SFT_CTX_LINE_GROWTH = 9,
  /** SFT_KPI_GROWTH_LEVEL_1 - KPI Growth Level 1 */
  SFT_KPI_GROWTH_LEVEL_1 = 100,
  /** SFT_KPI_GROWTH_LEVEL_2 - KPI Growth Level 2 */
  SFT_KPI_GROWTH_LEVEL_2 = 101,
  /** SFT_KPI_MARGINS_TOTAL - KPI Margins Total Item */
  SFT_KPI_MARGINS_TOTAL = 102,
  /** SFT_KPI_NWC_ITEM - KPI NWC Item */
  SFT_KPI_NWC_ITEM = 103,
  /** SFT_KPI_DEBT_RATIO_ITEM - KPI Debt Ratio Item */
  SFT_KPI_DEBT_RATIO_ITEM = 104,
  /** SFT_KPI_RETURN_RATION_ITEM - KPI Return Ratio Item */
  SFT_KPI_RETURN_RATION_ITEM = 105,
  /** SFT_KPI_CF_RUNWAY - KPI CF Runway Item */
  SFT_KPI_CF_RUNWAY = 106,
  /** SFT_KPI_CUSTOM_ITEM - KPI Custom Item */
  SFT_KPI_CUSTOM_ITEM = 200,
  UNRECOGNIZED = -1,
}

export function stcsFpnaTypeEnumFromJSON(object: any): StcsFpnaTypeEnum {
  switch (object) {
    case 0:
    case "SFT_ENUM_NONE":
      return StcsFpnaTypeEnum.SFT_ENUM_NONE;
    case 1:
    case "SFT_TOTAL_CML":
      return StcsFpnaTypeEnum.SFT_TOTAL_CML;
    case 2:
    case "SFT_TOTAL_NCML":
      return StcsFpnaTypeEnum.SFT_TOTAL_NCML;
    case 3:
    case "SFT_SUB_TOTAL":
      return StcsFpnaTypeEnum.SFT_SUB_TOTAL;
    case 4:
    case "SFT_LEVEL_1":
      return StcsFpnaTypeEnum.SFT_LEVEL_1;
    case 5:
    case "SFT_LEVEL_2":
      return StcsFpnaTypeEnum.SFT_LEVEL_2;
    case 6:
    case "SFT_LEVEL_3":
      return StcsFpnaTypeEnum.SFT_LEVEL_3;
    case 7:
    case "SFT_ACC_ITEM":
      return StcsFpnaTypeEnum.SFT_ACC_ITEM;
    case 8:
    case "SFT_CTX_LINE_IPO":
      return StcsFpnaTypeEnum.SFT_CTX_LINE_IPO;
    case 9:
    case "SFT_CTX_LINE_GROWTH":
      return StcsFpnaTypeEnum.SFT_CTX_LINE_GROWTH;
    case 100:
    case "SFT_KPI_GROWTH_LEVEL_1":
      return StcsFpnaTypeEnum.SFT_KPI_GROWTH_LEVEL_1;
    case 101:
    case "SFT_KPI_GROWTH_LEVEL_2":
      return StcsFpnaTypeEnum.SFT_KPI_GROWTH_LEVEL_2;
    case 102:
    case "SFT_KPI_MARGINS_TOTAL":
      return StcsFpnaTypeEnum.SFT_KPI_MARGINS_TOTAL;
    case 103:
    case "SFT_KPI_NWC_ITEM":
      return StcsFpnaTypeEnum.SFT_KPI_NWC_ITEM;
    case 104:
    case "SFT_KPI_DEBT_RATIO_ITEM":
      return StcsFpnaTypeEnum.SFT_KPI_DEBT_RATIO_ITEM;
    case 105:
    case "SFT_KPI_RETURN_RATION_ITEM":
      return StcsFpnaTypeEnum.SFT_KPI_RETURN_RATION_ITEM;
    case 106:
    case "SFT_KPI_CF_RUNWAY":
      return StcsFpnaTypeEnum.SFT_KPI_CF_RUNWAY;
    case 200:
    case "SFT_KPI_CUSTOM_ITEM":
      return StcsFpnaTypeEnum.SFT_KPI_CUSTOM_ITEM;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StcsFpnaTypeEnum.UNRECOGNIZED;
  }
}

export function stcsFpnaTypeEnumToJSON(object: StcsFpnaTypeEnum): string {
  switch (object) {
    case StcsFpnaTypeEnum.SFT_ENUM_NONE:
      return "SFT_ENUM_NONE";
    case StcsFpnaTypeEnum.SFT_TOTAL_CML:
      return "SFT_TOTAL_CML";
    case StcsFpnaTypeEnum.SFT_TOTAL_NCML:
      return "SFT_TOTAL_NCML";
    case StcsFpnaTypeEnum.SFT_SUB_TOTAL:
      return "SFT_SUB_TOTAL";
    case StcsFpnaTypeEnum.SFT_LEVEL_1:
      return "SFT_LEVEL_1";
    case StcsFpnaTypeEnum.SFT_LEVEL_2:
      return "SFT_LEVEL_2";
    case StcsFpnaTypeEnum.SFT_LEVEL_3:
      return "SFT_LEVEL_3";
    case StcsFpnaTypeEnum.SFT_ACC_ITEM:
      return "SFT_ACC_ITEM";
    case StcsFpnaTypeEnum.SFT_CTX_LINE_IPO:
      return "SFT_CTX_LINE_IPO";
    case StcsFpnaTypeEnum.SFT_CTX_LINE_GROWTH:
      return "SFT_CTX_LINE_GROWTH";
    case StcsFpnaTypeEnum.SFT_KPI_GROWTH_LEVEL_1:
      return "SFT_KPI_GROWTH_LEVEL_1";
    case StcsFpnaTypeEnum.SFT_KPI_GROWTH_LEVEL_2:
      return "SFT_KPI_GROWTH_LEVEL_2";
    case StcsFpnaTypeEnum.SFT_KPI_MARGINS_TOTAL:
      return "SFT_KPI_MARGINS_TOTAL";
    case StcsFpnaTypeEnum.SFT_KPI_NWC_ITEM:
      return "SFT_KPI_NWC_ITEM";
    case StcsFpnaTypeEnum.SFT_KPI_DEBT_RATIO_ITEM:
      return "SFT_KPI_DEBT_RATIO_ITEM";
    case StcsFpnaTypeEnum.SFT_KPI_RETURN_RATION_ITEM:
      return "SFT_KPI_RETURN_RATION_ITEM";
    case StcsFpnaTypeEnum.SFT_KPI_CF_RUNWAY:
      return "SFT_KPI_CF_RUNWAY";
    case StcsFpnaTypeEnum.SFT_KPI_CUSTOM_ITEM:
      return "SFT_KPI_CUSTOM_ITEM";
    case StcsFpnaTypeEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ExcelFileSchemaEnum {
  UDS_NONE = 0,
  UDS_BMD_A = 1,
  UDS_DATEV_A = 2,
  UDS_DATEV_B_EXCEL = 3,
  UDS_DATEV_B_CSV = 8,
  UDS_DATEV_C = 4,
  UDS_STCS_A = 5,
  UDS_SCHWEIGHOFER_A = 6,
  UDS_RZL_A = 7,
  /** UDS_RZL_B - RZL "Saldenliste" monthly CSV (per-file = 1 month; month parsed from filename) */
  UDS_RZL_B = 9,
  /** UDS_RZL_C - RZL "Saldenliste" yearly CSV (per-file = 12 months in column-per-month layout; year parsed from filename) */
  UDS_RZL_C = 10,
  UNRECOGNIZED = -1,
}

export function excelFileSchemaEnumFromJSON(object: any): ExcelFileSchemaEnum {
  switch (object) {
    case 0:
    case "UDS_NONE":
      return ExcelFileSchemaEnum.UDS_NONE;
    case 1:
    case "UDS_BMD_A":
      return ExcelFileSchemaEnum.UDS_BMD_A;
    case 2:
    case "UDS_DATEV_A":
      return ExcelFileSchemaEnum.UDS_DATEV_A;
    case 3:
    case "UDS_DATEV_B_EXCEL":
      return ExcelFileSchemaEnum.UDS_DATEV_B_EXCEL;
    case 8:
    case "UDS_DATEV_B_CSV":
      return ExcelFileSchemaEnum.UDS_DATEV_B_CSV;
    case 4:
    case "UDS_DATEV_C":
      return ExcelFileSchemaEnum.UDS_DATEV_C;
    case 5:
    case "UDS_STCS_A":
      return ExcelFileSchemaEnum.UDS_STCS_A;
    case 6:
    case "UDS_SCHWEIGHOFER_A":
      return ExcelFileSchemaEnum.UDS_SCHWEIGHOFER_A;
    case 7:
    case "UDS_RZL_A":
      return ExcelFileSchemaEnum.UDS_RZL_A;
    case 9:
    case "UDS_RZL_B":
      return ExcelFileSchemaEnum.UDS_RZL_B;
    case 10:
    case "UDS_RZL_C":
      return ExcelFileSchemaEnum.UDS_RZL_C;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ExcelFileSchemaEnum.UNRECOGNIZED;
  }
}

export function excelFileSchemaEnumToJSON(object: ExcelFileSchemaEnum): string {
  switch (object) {
    case ExcelFileSchemaEnum.UDS_NONE:
      return "UDS_NONE";
    case ExcelFileSchemaEnum.UDS_BMD_A:
      return "UDS_BMD_A";
    case ExcelFileSchemaEnum.UDS_DATEV_A:
      return "UDS_DATEV_A";
    case ExcelFileSchemaEnum.UDS_DATEV_B_EXCEL:
      return "UDS_DATEV_B_EXCEL";
    case ExcelFileSchemaEnum.UDS_DATEV_B_CSV:
      return "UDS_DATEV_B_CSV";
    case ExcelFileSchemaEnum.UDS_DATEV_C:
      return "UDS_DATEV_C";
    case ExcelFileSchemaEnum.UDS_STCS_A:
      return "UDS_STCS_A";
    case ExcelFileSchemaEnum.UDS_SCHWEIGHOFER_A:
      return "UDS_SCHWEIGHOFER_A";
    case ExcelFileSchemaEnum.UDS_RZL_A:
      return "UDS_RZL_A";
    case ExcelFileSchemaEnum.UDS_RZL_B:
      return "UDS_RZL_B";
    case ExcelFileSchemaEnum.UDS_RZL_C:
      return "UDS_RZL_C";
    case ExcelFileSchemaEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum AccNumberSchemaEnum {
  ANS_NONE = 0,
  ANS_BMD_100 = 1,
  ANS_DATEV_SKR_3 = 2,
  ANS_DATEV_SKR_4 = 3,
  UNRECOGNIZED = -1,
}

export function accNumberSchemaEnumFromJSON(object: any): AccNumberSchemaEnum {
  switch (object) {
    case 0:
    case "ANS_NONE":
      return AccNumberSchemaEnum.ANS_NONE;
    case 1:
    case "ANS_BMD_100":
      return AccNumberSchemaEnum.ANS_BMD_100;
    case 2:
    case "ANS_DATEV_SKR_3":
      return AccNumberSchemaEnum.ANS_DATEV_SKR_3;
    case 3:
    case "ANS_DATEV_SKR_4":
      return AccNumberSchemaEnum.ANS_DATEV_SKR_4;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AccNumberSchemaEnum.UNRECOGNIZED;
  }
}

export function accNumberSchemaEnumToJSON(object: AccNumberSchemaEnum): string {
  switch (object) {
    case AccNumberSchemaEnum.ANS_NONE:
      return "ANS_NONE";
    case AccNumberSchemaEnum.ANS_BMD_100:
      return "ANS_BMD_100";
    case AccNumberSchemaEnum.ANS_DATEV_SKR_3:
      return "ANS_DATEV_SKR_3";
    case AccNumberSchemaEnum.ANS_DATEV_SKR_4:
      return "ANS_DATEV_SKR_4";
    case AccNumberSchemaEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum StcsFstmtEnum {
  SFSE_NONE = 0,
  SFSE_PNL = 1,
  SFSE_BS = 2,
  SFSE_CF = 3,
  UNRECOGNIZED = -1,
}

export function stcsFstmtEnumFromJSON(object: any): StcsFstmtEnum {
  switch (object) {
    case 0:
    case "SFSE_NONE":
      return StcsFstmtEnum.SFSE_NONE;
    case 1:
    case "SFSE_PNL":
      return StcsFstmtEnum.SFSE_PNL;
    case 2:
    case "SFSE_BS":
      return StcsFstmtEnum.SFSE_BS;
    case 3:
    case "SFSE_CF":
      return StcsFstmtEnum.SFSE_CF;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StcsFstmtEnum.UNRECOGNIZED;
  }
}

export function stcsFstmtEnumToJSON(object: StcsFstmtEnum): string {
  switch (object) {
    case StcsFstmtEnum.SFSE_NONE:
      return "SFSE_NONE";
    case StcsFstmtEnum.SFSE_PNL:
      return "SFSE_PNL";
    case StcsFstmtEnum.SFSE_BS:
      return "SFSE_BS";
    case StcsFstmtEnum.SFSE_CF:
      return "SFSE_CF";
    case StcsFstmtEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum StcsKpiEnum {
  STCS_KPI_NONE = 0,
  STCS_KPI_GROWTH = 1,
  STCS_KPI_MARGIN = 2,
  STCS_KPI_NWC = 3,
  STCS_KPI_DEBT_RATIO = 4,
  STCS_KPI_RETURN_RATIO = 5,
  STCS_KPI_CUSTOM = 6,
  UNRECOGNIZED = -1,
}

export function stcsKpiEnumFromJSON(object: any): StcsKpiEnum {
  switch (object) {
    case 0:
    case "STCS_KPI_NONE":
      return StcsKpiEnum.STCS_KPI_NONE;
    case 1:
    case "STCS_KPI_GROWTH":
      return StcsKpiEnum.STCS_KPI_GROWTH;
    case 2:
    case "STCS_KPI_MARGIN":
      return StcsKpiEnum.STCS_KPI_MARGIN;
    case 3:
    case "STCS_KPI_NWC":
      return StcsKpiEnum.STCS_KPI_NWC;
    case 4:
    case "STCS_KPI_DEBT_RATIO":
      return StcsKpiEnum.STCS_KPI_DEBT_RATIO;
    case 5:
    case "STCS_KPI_RETURN_RATIO":
      return StcsKpiEnum.STCS_KPI_RETURN_RATIO;
    case 6:
    case "STCS_KPI_CUSTOM":
      return StcsKpiEnum.STCS_KPI_CUSTOM;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StcsKpiEnum.UNRECOGNIZED;
  }
}

export function stcsKpiEnumToJSON(object: StcsKpiEnum): string {
  switch (object) {
    case StcsKpiEnum.STCS_KPI_NONE:
      return "STCS_KPI_NONE";
    case StcsKpiEnum.STCS_KPI_GROWTH:
      return "STCS_KPI_GROWTH";
    case StcsKpiEnum.STCS_KPI_MARGIN:
      return "STCS_KPI_MARGIN";
    case StcsKpiEnum.STCS_KPI_NWC:
      return "STCS_KPI_NWC";
    case StcsKpiEnum.STCS_KPI_DEBT_RATIO:
      return "STCS_KPI_DEBT_RATIO";
    case StcsKpiEnum.STCS_KPI_RETURN_RATIO:
      return "STCS_KPI_RETURN_RATIO";
    case StcsKpiEnum.STCS_KPI_CUSTOM:
      return "STCS_KPI_CUSTOM";
    case StcsKpiEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum StcsAccDataSourceTypeEnum {
  SADST_NONE = 0,
  /** SADST_MANUAL_UPLOAD - Manual file upload */
  SADST_MANUAL_UPLOAD = 1,
  /** SADST_SYNC_DATEV - Datev sync */
  SADST_SYNC_DATEV = 2,
  /** SADST_SYNC_BMD - BMD sync */
  SADST_SYNC_BMD = 3,
  UNRECOGNIZED = -1,
}

export function stcsAccDataSourceTypeEnumFromJSON(object: any): StcsAccDataSourceTypeEnum {
  switch (object) {
    case 0:
    case "SADST_NONE":
      return StcsAccDataSourceTypeEnum.SADST_NONE;
    case 1:
    case "SADST_MANUAL_UPLOAD":
      return StcsAccDataSourceTypeEnum.SADST_MANUAL_UPLOAD;
    case 2:
    case "SADST_SYNC_DATEV":
      return StcsAccDataSourceTypeEnum.SADST_SYNC_DATEV;
    case 3:
    case "SADST_SYNC_BMD":
      return StcsAccDataSourceTypeEnum.SADST_SYNC_BMD;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StcsAccDataSourceTypeEnum.UNRECOGNIZED;
  }
}

export function stcsAccDataSourceTypeEnumToJSON(object: StcsAccDataSourceTypeEnum): string {
  switch (object) {
    case StcsAccDataSourceTypeEnum.SADST_NONE:
      return "SADST_NONE";
    case StcsAccDataSourceTypeEnum.SADST_MANUAL_UPLOAD:
      return "SADST_MANUAL_UPLOAD";
    case StcsAccDataSourceTypeEnum.SADST_SYNC_DATEV:
      return "SADST_SYNC_DATEV";
    case StcsAccDataSourceTypeEnum.SADST_SYNC_BMD:
      return "SADST_SYNC_BMD";
    case StcsAccDataSourceTypeEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Status codes for plan configuration items */
export enum StcsCalcItemStatusCode {
  /** PCI_STATUS_CODE_UNSPECIFIED - Default/unspecified status */
  PCI_STATUS_CODE_UNSPECIFIED = 0,
  /** PCI_STATUS_CODE_NOMINAL - Nominal/OK */
  PCI_STATUS_CODE_NOMINAL = 1,
  /** PCI_STATUS_CODE_SYNTAX_ERROR - Syntax error in formula or input */
  PCI_STATUS_CODE_SYNTAX_ERROR = 2,
  /** PCI_STATUS_CODE_CIRCULAR_REFERENCE - Circular reference detected */
  PCI_STATUS_CODE_CIRCULAR_REFERENCE = 3,
  /** PCI_STATUS_CODE_DIVISION_BY_ZERO - Division by zero error */
  PCI_STATUS_CODE_DIVISION_BY_ZERO = 4,
  /** PCI_STATUS_CODE_MISSING_REFERENCE - Missing reference in calculation */
  PCI_STATUS_CODE_MISSING_REFERENCE = 5,
  /** PCI_STATUS_CODE_OFFSET_OUTSIDE_DATASET - Offset outside available data */
  PCI_STATUS_CODE_OFFSET_OUTSIDE_DATASET = 6,
  /** PCI_STATUS_CODE_TECHNICAL_ISSUE - Technical/internal error */
  PCI_STATUS_CODE_TECHNICAL_ISSUE = 7,
  /** PCI_STATUS_CODE_MANUAL_OVERRIDE - Value manually overridden by user */
  PCI_STATUS_CODE_MANUAL_OVERRIDE = 8,
  /** PCI_STATUS_CODE_ERROR_IN_UNDERLYING_POS - Error in underlying position affecting this item */
  PCI_STATUS_CODE_ERROR_IN_UNDERLYING_POS = 9,
  /** PCI_STATUS_CODE_CIRCULAR_POSITIVE_OFFSET - Error: positive offset on self or parent not allowed */
  PCI_STATUS_CODE_CIRCULAR_POSITIVE_OFFSET = 10,
  UNRECOGNIZED = -1,
}

export function stcsCalcItemStatusCodeFromJSON(object: any): StcsCalcItemStatusCode {
  switch (object) {
    case 0:
    case "PCI_STATUS_CODE_UNSPECIFIED":
      return StcsCalcItemStatusCode.PCI_STATUS_CODE_UNSPECIFIED;
    case 1:
    case "PCI_STATUS_CODE_NOMINAL":
      return StcsCalcItemStatusCode.PCI_STATUS_CODE_NOMINAL;
    case 2:
    case "PCI_STATUS_CODE_SYNTAX_ERROR":
      return StcsCalcItemStatusCode.PCI_STATUS_CODE_SYNTAX_ERROR;
    case 3:
    case "PCI_STATUS_CODE_CIRCULAR_REFERENCE":
      return StcsCalcItemStatusCode.PCI_STATUS_CODE_CIRCULAR_REFERENCE;
    case 4:
    case "PCI_STATUS_CODE_DIVISION_BY_ZERO":
      return StcsCalcItemStatusCode.PCI_STATUS_CODE_DIVISION_BY_ZERO;
    case 5:
    case "PCI_STATUS_CODE_MISSING_REFERENCE":
      return StcsCalcItemStatusCode.PCI_STATUS_CODE_MISSING_REFERENCE;
    case 6:
    case "PCI_STATUS_CODE_OFFSET_OUTSIDE_DATASET":
      return StcsCalcItemStatusCode.PCI_STATUS_CODE_OFFSET_OUTSIDE_DATASET;
    case 7:
    case "PCI_STATUS_CODE_TECHNICAL_ISSUE":
      return StcsCalcItemStatusCode.PCI_STATUS_CODE_TECHNICAL_ISSUE;
    case 8:
    case "PCI_STATUS_CODE_MANUAL_OVERRIDE":
      return StcsCalcItemStatusCode.PCI_STATUS_CODE_MANUAL_OVERRIDE;
    case 9:
    case "PCI_STATUS_CODE_ERROR_IN_UNDERLYING_POS":
      return StcsCalcItemStatusCode.PCI_STATUS_CODE_ERROR_IN_UNDERLYING_POS;
    case 10:
    case "PCI_STATUS_CODE_CIRCULAR_POSITIVE_OFFSET":
      return StcsCalcItemStatusCode.PCI_STATUS_CODE_CIRCULAR_POSITIVE_OFFSET;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StcsCalcItemStatusCode.UNRECOGNIZED;
  }
}

export function stcsCalcItemStatusCodeToJSON(object: StcsCalcItemStatusCode): string {
  switch (object) {
    case StcsCalcItemStatusCode.PCI_STATUS_CODE_UNSPECIFIED:
      return "PCI_STATUS_CODE_UNSPECIFIED";
    case StcsCalcItemStatusCode.PCI_STATUS_CODE_NOMINAL:
      return "PCI_STATUS_CODE_NOMINAL";
    case StcsCalcItemStatusCode.PCI_STATUS_CODE_SYNTAX_ERROR:
      return "PCI_STATUS_CODE_SYNTAX_ERROR";
    case StcsCalcItemStatusCode.PCI_STATUS_CODE_CIRCULAR_REFERENCE:
      return "PCI_STATUS_CODE_CIRCULAR_REFERENCE";
    case StcsCalcItemStatusCode.PCI_STATUS_CODE_DIVISION_BY_ZERO:
      return "PCI_STATUS_CODE_DIVISION_BY_ZERO";
    case StcsCalcItemStatusCode.PCI_STATUS_CODE_MISSING_REFERENCE:
      return "PCI_STATUS_CODE_MISSING_REFERENCE";
    case StcsCalcItemStatusCode.PCI_STATUS_CODE_OFFSET_OUTSIDE_DATASET:
      return "PCI_STATUS_CODE_OFFSET_OUTSIDE_DATASET";
    case StcsCalcItemStatusCode.PCI_STATUS_CODE_TECHNICAL_ISSUE:
      return "PCI_STATUS_CODE_TECHNICAL_ISSUE";
    case StcsCalcItemStatusCode.PCI_STATUS_CODE_MANUAL_OVERRIDE:
      return "PCI_STATUS_CODE_MANUAL_OVERRIDE";
    case StcsCalcItemStatusCode.PCI_STATUS_CODE_ERROR_IN_UNDERLYING_POS:
      return "PCI_STATUS_CODE_ERROR_IN_UNDERLYING_POS";
    case StcsCalcItemStatusCode.PCI_STATUS_CODE_CIRCULAR_POSITIVE_OFFSET:
      return "PCI_STATUS_CODE_CIRCULAR_POSITIVE_OFFSET";
    case StcsCalcItemStatusCode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum StcsDisplayValueTypeEnum {
  SDVTE_NONE = 0,
  SDVTE_CURRENCY = 1,
  SDVTE_PERCENTAGE = 2,
  SDVTE_ABSOLUTE = 3,
  UNRECOGNIZED = -1,
}

export function stcsDisplayValueTypeEnumFromJSON(object: any): StcsDisplayValueTypeEnum {
  switch (object) {
    case 0:
    case "SDVTE_NONE":
      return StcsDisplayValueTypeEnum.SDVTE_NONE;
    case 1:
    case "SDVTE_CURRENCY":
      return StcsDisplayValueTypeEnum.SDVTE_CURRENCY;
    case 2:
    case "SDVTE_PERCENTAGE":
      return StcsDisplayValueTypeEnum.SDVTE_PERCENTAGE;
    case 3:
    case "SDVTE_ABSOLUTE":
      return StcsDisplayValueTypeEnum.SDVTE_ABSOLUTE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StcsDisplayValueTypeEnum.UNRECOGNIZED;
  }
}

export function stcsDisplayValueTypeEnumToJSON(object: StcsDisplayValueTypeEnum): string {
  switch (object) {
    case StcsDisplayValueTypeEnum.SDVTE_NONE:
      return "SDVTE_NONE";
    case StcsDisplayValueTypeEnum.SDVTE_CURRENCY:
      return "SDVTE_CURRENCY";
    case StcsDisplayValueTypeEnum.SDVTE_PERCENTAGE:
      return "SDVTE_PERCENTAGE";
    case StcsDisplayValueTypeEnum.SDVTE_ABSOLUTE:
      return "SDVTE_ABSOLUTE";
    case StcsDisplayValueTypeEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum KpiPosActivationModeEnum {
  /** KPAM_UNSPECIFIED - Default: position always active (backward compatible) */
  KPAM_UNSPECIFIED = 0,
  /** KPAM_ACTUALS_ONLY - Active only when no plan data is available */
  KPAM_ACTUALS_ONLY = 1,
  /** KPAM_PLAN_ONLY - Active only when plan data is available */
  KPAM_PLAN_ONLY = 2,
  /** KPAM_BOTH - Active regardless of plan availability */
  KPAM_BOTH = 3,
  UNRECOGNIZED = -1,
}

export function kpiPosActivationModeEnumFromJSON(object: any): KpiPosActivationModeEnum {
  switch (object) {
    case 0:
    case "KPAM_UNSPECIFIED":
      return KpiPosActivationModeEnum.KPAM_UNSPECIFIED;
    case 1:
    case "KPAM_ACTUALS_ONLY":
      return KpiPosActivationModeEnum.KPAM_ACTUALS_ONLY;
    case 2:
    case "KPAM_PLAN_ONLY":
      return KpiPosActivationModeEnum.KPAM_PLAN_ONLY;
    case 3:
    case "KPAM_BOTH":
      return KpiPosActivationModeEnum.KPAM_BOTH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return KpiPosActivationModeEnum.UNRECOGNIZED;
  }
}

export function kpiPosActivationModeEnumToJSON(object: KpiPosActivationModeEnum): string {
  switch (object) {
    case KpiPosActivationModeEnum.KPAM_UNSPECIFIED:
      return "KPAM_UNSPECIFIED";
    case KpiPosActivationModeEnum.KPAM_ACTUALS_ONLY:
      return "KPAM_ACTUALS_ONLY";
    case KpiPosActivationModeEnum.KPAM_PLAN_ONLY:
      return "KPAM_PLAN_ONLY";
    case KpiPosActivationModeEnum.KPAM_BOTH:
      return "KPAM_BOTH";
    case KpiPosActivationModeEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum StcsFpnaAggregationEnum {
  SFAE_NONE = 0,
  SFAE_SUM = 1,
  SFAE_AVERAGE = 2,
  SFAE_MAX = 3,
  SFAE_MIN = 4,
  UNRECOGNIZED = -1,
}

export function stcsFpnaAggregationEnumFromJSON(object: any): StcsFpnaAggregationEnum {
  switch (object) {
    case 0:
    case "SFAE_NONE":
      return StcsFpnaAggregationEnum.SFAE_NONE;
    case 1:
    case "SFAE_SUM":
      return StcsFpnaAggregationEnum.SFAE_SUM;
    case 2:
    case "SFAE_AVERAGE":
      return StcsFpnaAggregationEnum.SFAE_AVERAGE;
    case 3:
    case "SFAE_MAX":
      return StcsFpnaAggregationEnum.SFAE_MAX;
    case 4:
    case "SFAE_MIN":
      return StcsFpnaAggregationEnum.SFAE_MIN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StcsFpnaAggregationEnum.UNRECOGNIZED;
  }
}

export function stcsFpnaAggregationEnumToJSON(object: StcsFpnaAggregationEnum): string {
  switch (object) {
    case StcsFpnaAggregationEnum.SFAE_NONE:
      return "SFAE_NONE";
    case StcsFpnaAggregationEnum.SFAE_SUM:
      return "SFAE_SUM";
    case StcsFpnaAggregationEnum.SFAE_AVERAGE:
      return "SFAE_AVERAGE";
    case StcsFpnaAggregationEnum.SFAE_MAX:
      return "SFAE_MAX";
    case StcsFpnaAggregationEnum.SFAE_MIN:
      return "SFAE_MIN";
    case StcsFpnaAggregationEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum StcsSubProductCycleEnum {
  SPSC_NONE = 0,
  SPSC_MONTHLY = 1,
  SPSC_QUARTERLY = 2,
  SPSC_SEMI_ANNUALLY = 3,
  SPSC_ANNUALLY = 4,
  UNRECOGNIZED = -1,
}

export function stcsSubProductCycleEnumFromJSON(object: any): StcsSubProductCycleEnum {
  switch (object) {
    case 0:
    case "SPSC_NONE":
      return StcsSubProductCycleEnum.SPSC_NONE;
    case 1:
    case "SPSC_MONTHLY":
      return StcsSubProductCycleEnum.SPSC_MONTHLY;
    case 2:
    case "SPSC_QUARTERLY":
      return StcsSubProductCycleEnum.SPSC_QUARTERLY;
    case 3:
    case "SPSC_SEMI_ANNUALLY":
      return StcsSubProductCycleEnum.SPSC_SEMI_ANNUALLY;
    case 4:
    case "SPSC_ANNUALLY":
      return StcsSubProductCycleEnum.SPSC_ANNUALLY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StcsSubProductCycleEnum.UNRECOGNIZED;
  }
}

export function stcsSubProductCycleEnumToJSON(object: StcsSubProductCycleEnum): string {
  switch (object) {
    case StcsSubProductCycleEnum.SPSC_NONE:
      return "SPSC_NONE";
    case StcsSubProductCycleEnum.SPSC_MONTHLY:
      return "SPSC_MONTHLY";
    case StcsSubProductCycleEnum.SPSC_QUARTERLY:
      return "SPSC_QUARTERLY";
    case StcsSubProductCycleEnum.SPSC_SEMI_ANNUALLY:
      return "SPSC_SEMI_ANNUALLY";
    case StcsSubProductCycleEnum.SPSC_ANNUALLY:
      return "SPSC_ANNUALLY";
    case StcsSubProductCycleEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
